// extracted by mini-css-extract-plugin
module.exports = {"label":"stylers_label__5LhqF"};